import { render, staticRenderFns } from "./SchoolWorkingSectionExportLegend.vue?vue&type=template&id=367be541&scoped=true&"
import script from "./SchoolWorkingSectionExportLegend.vue?vue&type=script&lang=js&"
export * from "./SchoolWorkingSectionExportLegend.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "367be541",
  null
  
)

export default component.exports